import {
  CHANGE_LANGUAGE,
  GET_SYSTEM_NOTIFICATION_SUCCESS,
  GET_TIER_SUCCESS,
  GET_VENUE_SUCCESS,
  SET_SHOW_NAV,
  GET_LISTING_TYPE_SUCCESS,
  UPDATE_LISTING_TYPE,
  GET_APP_SETTINGS_SUCCESS,
  GET_BEPOZ_CUSTOMFIELD_META_SUCCESS,
  GET_TAGS_SUCCESS,
  GET_POS_VERSION_SUCCESS,
  GET_SSO_VERSION_SUCCESS,
  SET_GLOBAL_INDICATOR_VISIBILITY,
  SET_SYNC_VOUCHER,
  SET_SYNC_PROMOTION,
  GET_LOGIN_SETTING_SUCCESS,
  SET_POPUP_MESSAGE,
} from '../actions/app'
import {USER_LOGOUT} from '../actions/user'
import {MEMBER_LOGOUT} from '../actions/member'

export default function app(
  state = {
    sidebarShow: false,
    ssoVersion: '',
  },
  action,
) {
  switch (action.type) {
    case CHANGE_LANGUAGE:
      return {
        ...state,
        language: action.language,
      }
    case SET_SHOW_NAV:
      return {
        ...state,
        sidebarShow: action.payload,
      }
    case GET_TIER_SUCCESS:
      return {
        ...state,
        tier: action.payload,
      }
    case GET_SYSTEM_NOTIFICATION_SUCCESS:
      return {
        ...state,
        systemNotification: action.payload,
      }
    case GET_VENUE_SUCCESS:
      return {
        ...state,
        venues: action.payload,
      }
    case GET_POS_VERSION_SUCCESS:
      return {
        ...state,
        posVersion: action.payload || false,
      }
    case GET_SSO_VERSION_SUCCESS:
      return {
        ...state,
        ssoVersion: action.payload || '',
      }
    case GET_TAGS_SUCCESS:
      return {
        ...state,
        tags: action.payload,
      }
    case GET_LISTING_TYPE_SUCCESS:
      return {
        ...state,
        listing: action.payload,
      }
    case UPDATE_LISTING_TYPE:
      let newList = [...state.listing]
      let index = newList.findIndex((item) => item.id === action.payload?.id)
      if (index > -1) {
        newList[index] = action.payload
      }
      return {
        ...state,
        listing: newList,
      }
    case GET_APP_SETTINGS_SUCCESS:
      const region = action.payload.region.value
      let currency = 'AUD$'
      switch (region) {
        case 'us':
          currency = 'US$'
          break
        case 'uk':
          currency = '£'
          break
        case 'nz':
          currency = 'NZ$'
          break
        default:
          currency = 'AUD$'
          break
      }
      return {
        ...state,
        appSettings: action.payload,
        currency: currency,
      }
    case GET_BEPOZ_CUSTOMFIELD_META_SUCCESS:
      return {
        ...state,
        bepozCustomFieldMeta: action.payload || [],
      }
    case SET_GLOBAL_INDICATOR_VISIBILITY:
      return {
        ...state,
        showGlobalIndicator: action.visible,
      }
    case SET_SYNC_VOUCHER:
      return {
        ...state,
        ifSyncVoucher: action.ifSyncVoucher,
      }
    case SET_SYNC_PROMOTION:
      return {
        ...state,
        ifSyncPromotion: action.ifSyncPromotion,
      }
    case GET_LOGIN_SETTING_SUCCESS:
      return {
        ...state,
        loginSetting: action.payload,
      }
    case USER_LOGOUT:
      return {
        ...state,
      }
    case MEMBER_LOGOUT:
      return {
        ...state,
      }
    case SET_POPUP_MESSAGE:
      return {
        ...state,
        popupMessage: action.payload,
      }
    default:
      return state
  }
}
